import { jsx as r, Fragment as b } from "react/jsx-runtime";
import { useStyleConfig as f, Button as g } from "@chakra-ui/react";
import { getISOWeek as t } from "../../node_modules/date-fns/getISOWeek.js";
import { ThemeSpaceVariable as i, ThemeRadiusVariable as l, ThemeColorVariable as m } from "../../theme/theme-types.js";
const k = ({
  gridIndex: s,
  handleWeekChange: d,
  variant: e,
  date: o,
  selectWeek: n,
  isDisabled: a
}) => {
  const u = f("DateCell", { variant: e }), c = Math.floor(s / 7) + 1;
  return /* @__PURE__ */ r(b, { children: /* @__PURE__ */ r(
    g,
    {
      sx: {
        color: e === "selectedDay" ? m.OnAccent : m.OnSurfaceSubdued,
        marginRight: i.None
      },
      borderRightRadius: 0,
      borderTopLeftRadius: l.Medium,
      borderBottomLeftRadius: l.Medium,
      __css: u,
      type: "button",
      variant: e,
      onClick: () => d(o),
      gridColumn: 1,
      gridRow: c,
      "data-testid": `week-number-${t(o)}`,
      isDisabled: !n || a,
      ml: i.None,
      children: t(o)
    }
  ) });
};
export {
  k as DatePickerWeekCell
};
